export default "__VITE_ASSET__c50b7877__"